import React, { useEffect } from 'react';
import FullPageLoader from 'components/Loader/FullPageLoader/FullPageLoader';
import {
  decodeJwt,
  getAuthInfoFromHash,
  getExpiryDate,
  getNonce,
  setAuthToken,
} from 'utils/auth.util';
import { useLocation, useNavigate } from 'react-router';
import { removeAllPermissionsCookies } from '../../../utils/permissions.util';
import { CLOSE_POPUP_WINDOW } from '../../../constants/auth';

function OAuthTokenSetter() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, hash } = location;

  useEffect(() => {
    const { token, state } = getAuthInfoFromHash(hash);

    const decodedToken = decodeJwt(token);

    if (decodedToken && decodedToken.nonce === getNonce()) {
      removeAllPermissionsCookies();
      setAuthToken(token, getExpiryDate(decodedToken));
      if (state === CLOSE_POPUP_WINDOW) {
        window.close();
      }
      navigate(`${pathname}${decodeURIComponent(state)}`, { replace: true });
    } else {
      throw new Error('Bad auth token');
    }
  }, [hash, navigate, pathname]);

  return <FullPageLoader />;
}

export default OAuthTokenSetter;
